/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 */
//入口
// import { order } from '../../api';
// import importAll from '@/tools/importAll';
// const children  = importAll(require.context('./'))

import { orderManagement } from '@/api/ajax';
import fields from '@/page/settlementCenter/projectSettled/common/fields.js';
import search from '@/page/settlementCenter/projectSettled/common/search.js';
import _fields from './fields.js';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { setAllCacheCheck } from '../service.js';
import { activityName } from '@/page/settlementCenter/common/tableConfig/search';
import { agreementServiceActivityName } from '@/page/settlementCenter/common/tableConfig/fields';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';

//初始化
const example = new TableRenderClass({
  fields: { ...fields, ..._fields },
  search
});
/**
 * @description: 封装isCheck，适配selectAllByRowKey数据结构
 * @param {object} query http://yapi.jimijiayuan.cn/project/657/interface/api/20207
 * @return {object} request object
 */
const selectAllPeople = (
  query = {
    isAll: 1
  }
) => {
  return new Promise(async resolve => {
    const resp = await setAllCacheCheck(query);
    resolve({
      data: {
        data: resp.cacheIds.map(item => ({
          id: +item,
          isChecked: 1 // 该混合没用。只可设置id，通过ID匹配数据
        }))
      }
    });
  });
};
// 结算订单生成
export const step_0 = [
  {
    name: '结算订单生成',
    childMenu: [
      example.createPart({
        name: '待结算订单|创建',
        list: orderManagement.getOrderPeopleList,
        requestNow: true,
        search: [
          'createProjectId',
          'xiangmucanyuren',
          'jiesuangongyingshang',
          'shoujihao',
          'taxCollectionPattern',
          activityName,
          'submitDt',
          'industryFenpeiCode',
          PAY_BANK_TYPE_KEY,
          PAY_TYPE_KEY
        ],
        fields: [
          {
            type: 'selection',
            reserve: true,
            width: '40',
            prop: 'id',
            selectable(row) {
              return row.zbBlackStatus !== 2;
            }
          },
          'index',
          'xiangmucanyuren',
          'shoujihao',
          'shoukuanzhanghao',
          'xiangmumingcheng',
          PAY_BANK_TYPE_KEY,
          PAY_TYPE_KEY,
          agreementServiceActivityName,
          'createDt',
          'industryFenpeiCode',
          'taxCollectionPattern',
          'supplierName',
          'zhongduanjiesuandanjia',
          'zhongduanjiesuanjine',
          'serviceRate',
          'initFinishSum',
          'taskNumHandler',
          'totalPrice'
        ],
        moreBtnArr: [
          {
            name: '全部加入',
            fn: async (a, table) => {
              const selection = await table.selectAllByRowKey({
                listAjax: selectAllPeople.bind(null, {
                  isAll: 1,
                  ...table.searchQuery
                }),
                useSeachInit: false
              });
              // 修改isChecked标识，设为已选中
              selection.forEach(item => {
                item.isChecked = 1;
              });
              // 让列表获取到选择数据 src\page\settlementCenter\projectSettled\child\orderCreate.vue
              table.$parent.$parent.selection = selection;
              // let parent = table['$parent'];

              // while (parent['$parent']) {
              // 	if (parent['$options'].name === 'orderCreate') {
              // 		break;
              // 	}
              // 	parent = parent['$parent'];
              // }

              // parent.selection=[...selection]

              // parent.selectA ll()
            }
          }
        ]
      })
    ]
  }
];

// 结算订单生成 确认笔数.
export const step_1 = [
  {
    name: '结算订单生成确认',
    childMenu: [
      example.createPart({
        name: '结算订单生成确认',
        list: orderManagement.getConfirmOrderPeopleList,
        requestNow: false,
        fields: [
          'id',
          'index',
          'xiangmucanyuren',
          'shoujihao',
          'shoukuanzhanghao',
          'xiangmumingcheng',
          'taxCollectionPattern',
          'supplierName',
          'jiesuanrenwuliang',
          'zhongduanjiesuandanjia',
          'zhongduanjiesuanjine',
          'serviceRate',
          'totalPrice'
        ],
        moreBtnArr: []
      })
    ]
  }
];

// 订单信息确认
export const step_2 = [
  {
    name: '订单信息确认',
    childMenu: [
      example.createPart({
        name: '订单信息确认',
        list: orderManagement.getConfirmOrderPeopleList,
        fields: [
          // '_superKey',
          'index',
          'xiangmucanyuren',
          'shoujihao',
          'shoukuanzhanghao',
          'xiangmumingcheng',
          'supplierName',
          'taxCollectionPattern',
          'jiesuanrenwuliang',
          'zhongduanjiesuandanjia',
          'zhongduanjiesuanjine',
          'serviceRate',
          'totalPrice'
        ]
      })
    ]
  }
];
